import { useLanguage } from "@/context/LanguageContext";

const STYLES = {
  pending: "bg-amber-100 text-amber-800 border-amber-300",
  preparing: "bg-blue-100 text-blue-800 border-blue-300",
  ready: "bg-emerald-100 text-emerald-800 border-emerald-300",
  completed: "bg-stone-100 text-stone-700 border-stone-300",
};

export function StatusBadge({ status }) {
  const { t } = useLanguage();
  return (
    <span data-testid={`status-badge-${status}`} className={`text-xs font-bold uppercase tracking-wide border rounded-full px-3 py-1 ${STYLES[status] || STYLES.pending}`}>
      {t(`status_${status}`)}
    </span>
  );
}

export function PaymentBadge({ paid, full = false }) {
  const { t } = useLanguage();
  return (
    <span
      data-testid={paid ? "payment-badge-paid" : "payment-badge-unpaid"}
      className={`text-xs font-bold uppercase tracking-wide border rounded-full px-3 py-1 whitespace-nowrap ${
        paid
          ? "bg-emerald-100 text-emerald-800 border-emerald-300"
          : "bg-orange-100 text-orange-800 border-orange-300"
      }`}
    >
      {paid ? (full ? t("pay_paid_full") : t("pay_paid")) : t("pay_unpaid")}
    </span>
  );
}
